export default __webpack_public_path__ + "static/media/SeriesBookletIcon.ce0bcbef.svg";